<div style="height: 80vh;" class="container d-flex flex-column justify-content-center align-items-center">
    <h3>Pagina non trovata</h3>
    <p><a [routerLink]="['/']">Ritorna alla pagina iniziale</a></p>
</div>
